import { IUIStrings } from "./IUIStrings";

export const EN: IUIStrings = {
  PreparingMailCloning: "Preparing to clone mail...",
  CloningMail: "Cloning email...",
  MailCloned: "Mail cloned!",
  AnErrorOccurred: "An error occurred, please try again later.",
  ErrorWhileCloning: "Error when cloning email.",
};

export default EN;